import React, { useEffect } from 'react';

import { Button } from '@gn-audio/jss-components';

import { StepContainer } from '../components/StepContainer';
import { useHearingTest, useHearingTestTracking } from '../HearingTestContext';
import { translations } from '../translations/en';
import { STEP_NAMES, TOTAL_STEPS } from '../types/HearingTestTypes';
import { HearingTestEventAction } from '../types/TrackingTypes';

export const IntroductionStep: React.FC = () => {
  const { state, goToStep } = useHearingTest();
  const { trackHearingTestEvent } = useHearingTestTracking();

  useEffect(() => {
    trackHearingTestEvent(HearingTestEventAction.LoadPage, 'Introduction');
  }, [trackHearingTestEvent]);

  const handleStart = () => {
    trackHearingTestEvent(HearingTestEventAction.Click, 'Start test');
    goToStep(STEP_NAMES.GENERAL_QUESTIONS);
  };

  return (
    <StepContainer currentStep={state.currentStep} totalSteps={TOTAL_STEPS}>
      <div className="space-y-8">
        <div className="mb-8">
          <h1 className="mb-4 text-3xl font-bold text-gray-900">{translations.welcome}</h1>
          <p className="mb-2 text-xl text-gray-700">{translations.knowmore}</p>
          <p className="text-xl text-gray-700">{translations.grabheadphones}</p>
        </div>

        <div className="mb-8 rounded-lg bg-gray-50 p-6">
          <p className="mb-4 text-lg font-semibold text-gray-800">{translations.disclaimer}</p>
          <p className="mb-4 text-gray-700">{translations.disclaimer1}</p>
          <p className="mb-4 text-gray-700">{translations.disclaimer2}</p>
          <div
            className="text-gray-700"
            dangerouslySetInnerHTML={{ __html: translations.disclaimer3 }}
          />
        </div>

        <div className="text-center">
          <Button onClick={handleStart} variant="primary" size="l" className="text-lg">
            {translations.starttest}
          </Button>
        </div>
      </div>
    </StepContainer>
  );
};
